module.exports = __webpack_public_path__ + "static/media/gas-pump-slash.353f2383.svg";